import { TAB } from '~/constants/Tab';

import ToastService from '~/services/toast.service';

import { log } from '~/utils/logging';

/**
 * Deletes a filter group from the list of filter groups.
 *
 * @param {Object} params - The parameters for the function.
 * @param {function} params.dispatch - The dispatch function for Redux.
 * @param {Array} params.filterGroups - The list of filter groups.
 * @param {string} params.selectedFilterGroupId - The ID of the filter group to be deleted.
 * @param {function} params.setDelivery_filterGroups - The function to set the updated filter groups.
 * @param {function} params.setDelivery_selectedFilterGroup - The function to set the selected filter group.
 * @param {function} params.handleChangeFilterGroup - The function to handle changes of the selected filter group.
 * @param {function} params.updateUserSettings - The function to update filter groups on back-end.
 * @return {void}
 */
export const deleteFilterGroup = async ({
  dispatch,
  filterGroups,
  selectedFilterGroupId,
  setDelivery_filterGroups,
  setDelivery_selectedFilterGroup,
  handleChangeFilterGroup,
  updateUserSettings,
}) => {
  const newFilterGroups = filterGroups.filter(
    ({ id }) => id !== selectedFilterGroupId,
  );

  await updateUserSettings(
    { webappDeliveryFilterGroups: newFilterGroups },
    {
      onError(error) {
        log.error({ message: 'Failed to delete filter group.', error });

        ToastService.error(['Filter konnte nicht gelöscht werden.']);

        throw error; // Re-throw error to be caught by calling function
      },
    },
  );

  dispatch(setDelivery_filterGroups(newFilterGroups));
  dispatch(
    setDelivery_selectedFilterGroup(filterGroups[TAB.DELIVERY.LIST.INDEX].id),
  );

  handleChangeFilterGroup(filterGroups[TAB.DELIVERY.LIST.INDEX]);
};
